import styles from "./styles.module.scss";

export function NoData() {
  return (
    <div className={styles.container}>
      <p>No data available</p>
    </div>
  );
}
